import {HiShieldCheck} from "react-icons/hi";
import Button from "../Button";
import {useContext} from "react";
import UserAuthenticationContext from "../../tools/contexts/authenticatonService/UserAuthenticationContext";
import TransactionalCreditContext from "../../tools/contexts/transationcalCredit/TransactionalCreditContext";

const Final = () => {
    const transactionalCreditContext=useContext(TransactionalCreditContext)
    const handleRedirect = () => {
        const price = transactionalCreditContext?.process?.payment?.info ? transactionalCreditContext.process.payment.info.init_amount : null
        return transactionalCreditContext.handleRedirectToDivar({price, status: "success"})
    }
    return <div>
        <div className="flex justify-center mt-10">
            <h1 className="text-3xl text-gray-600  ">
                ونیفای
            </h1>
        </div>
        <div
            className="w-11/12 md:w-6/12 mx-auto  flex flex-col mt-5 justify-center items-center  lg:w-5/12 xl:w-4/12 bg-white rounded-lg p-5 ">
            <HiShieldCheck className="text-5xl mb-7 text-green-500"/>
            <h1 className="font-bold text-2xl text-gray-700 mb-4 ">موفق</h1>
            <p className="text-sm mb-2  text-center">درخواست شما با موفقیت به مراجع قانونی ارسال شد نتیجه درخواست شما تا  30 دقیقه دیگر بر روی آگهی قرار خواهد گرفت. نتیجه نهایی از طریق پیامک برای شما ارسال می گردد.</p>


            <Button onClick={handleRedirect} className="mt-5 w-full lg:w-10/12 rounded-lg text-sm" theme="green">بازگشت به دیوار</Button>
        </div>
    </div>
}
export default Final;